import { render } from "./ParagraphBlock.vue?vue&type=template&id=80f2fc44"
import script from "./ParagraphBlock.vue?vue&type=script&lang=js"
export * from "./ParagraphBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__